import { defineComponent as _defineComponent } from 'vue'
import { ref, computed } from 'vue';

import { modals } from '@modals';
import type { Faq } from '@models';

import { faStar } from '@icons/solid/faStar';
import { faTag } from '@icons/solid/faTag';
import { faPlus } from '@icons/regular/faPlus';
import { faMinus } from '@icons/regular/faMinus';

export interface Props {
  id: string;
  title: string;
  body: Faq.BodyItem[];
  subjects: string[];
  showChat: boolean;
  tags: string[];
  topFaq: boolean;
  expanded: boolean;
}

/** `FaqCard` component emits. */
export type Emits = (event: 'toggled', id: string) => void;


export default /*#__PURE__*/_defineComponent({
  __name: 'FaqCard',
  props: {
    id: null,
    title: null,
    body: null,
    subjects: null,
    showChat: { type: Boolean },
    tags: null,
    topFaq: { type: Boolean },
    expanded: { type: Boolean }
  },
  emits: ["toggled"],
  setup(__props: any, { emit }: { emit: ((event: 'toggled', id: string) => void), expose: any, slots: any, attrs: any }) {

const props = __props as {
  id: string;
  title: string;
  body: Faq.BodyItem[];
  subjects: string[];
  showChat: boolean;
  tags: string[];
  topFaq: boolean;
  expanded: boolean;
};

const SUPPORT_MODAL_CONFIG = {
  title: 'SUPPORT',
  text: 'You can email us at support@littlearms.com with your support question. We will respond as soon as we receive your message.',
};

/**
 * `FaqCard` component properties.
 */




const internalExpanded = ref(false);

const expandedSet = computed(() => props.expanded);

const open = computed({
  get: () => {
    return expandedSet.value ? props.expanded : internalExpanded.value;
  },
  set: (value) => {
    if (!expandedSet.value) {
      internalExpanded.value = value;
    }
  },
});

const elements = computed(() => {
  return props.body.map((item) => {
    if (item.type === 'video') {
      item.content = `https://www.youtube.com/embed/${item.content}`;

      return item;
    }

    if (item.type !== 'text') return item;

    const getFaqIdRegex = /\[(.*?)\]/;
    const [, faqId] = item.content.match(getFaqIdRegex) ?? [];

    if (!faqId) return item;

    const text = item.content.replace(
      `<a href="#" [${faqId}]">`,
      `<a href="#" data-faq-id="${faqId}" onclick="dispatchEvent.value(new Event('linked', { bubbles: true }));">`,
    );

    return { ...item, content: text };
  });
});

function toggle() {
  if (expandedSet.value) {
    emit('toggled', props.id);
  } else {
    internalExpanded.value = !internalExpanded.value;
  }
}

function contactSupport() {
  void modals.util.generalInfo(SUPPORT_MODAL_CONFIG);
}

return { __sfc: true,SUPPORT_MODAL_CONFIG, props, emit, internalExpanded, expandedSet, open, elements, toggle, contactSupport, faStar, faTag, faPlus, faMinus }
}

})